export const ALLOW_SERVICE = 'ALLOW_SERVICE'
export const DISALLOW_SERVICE = 'DISALLOW_SERVICE'
